import { connect } from 'react-redux'
import FeedItemViewPage from '../components/FeedItemViewPage'

import { actionCreators as feedItemsActionCreators } from '@app/components/FeedItem/modules/feedItems'

export default connect(
  null,
  feedItemsActionCreators,
)(FeedItemViewPage)
